module.exports = __webpack_public_path__ + "static/img/1055.108aa10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1055.jpg
// module id = 237
// module chunks = 0